import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Home, Compare, Admin, CaseDetail, PrivacyPolicy, AmazonDisclosure } from './pages';

const AppRoutes: React.FC = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/case/:id" element={<CaseDetail />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/amazon-disclosure" element={<AmazonDisclosure />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
